import { createFileRoute } from '@tanstack/react-router'
import { orpc } from '@/utils/orpc'
import { useQuery } from '@tanstack/react-query'
import { useAuthValue } from '@/stores/auth-store'
import { useUserValue } from '@/stores/user-store'
import Loader from '@/components/loader'
import { FarmerCard } from '@/components/farmer-card'
import { getUserIdentifier } from '@/utils/shared'
import { isSuccessResponse } from '@shamba-odk/types'

export const Route = createFileRoute('/_authenticated/farmers')({
  component: FarmersDashboardComponent,
})

function FarmersDashboardComponent() {
  const accessToken = useAuthValue("accessToken");
  const user = getUserIdentifier(useUserValue("name"), useUserValue("email"));
  const farmers = useQuery(orpc.frappe.getDocs.queryOptions({
    input: {
      accessToken: accessToken,
      doctype: "AA Farmer",
      owner: user,
    },
    staleTime: 10_000,
    select: (response) => {
      if (isSuccessResponse(response)) {
        return response.data;
      }
      throw new Error(response.error.exc_type || 'Failed to fetch farmers');
    }
  }))

  if (farmers.isLoading) {
    return <Loader />
  }

  if (farmers.isError) {
    return <div>Error: {farmers.error.message}</div>
  }

  return (
    <div className="flex items-center justify-center">
      <div className="h-full w-full max-w-xl py-4 flex flex-col gap-4 justify-center items-center">
        <h2 className="text-2xl font-bold">
          Registered Farmers
        </h2>
        <ul className="flex flex-col gap-2">
          {farmers.data?.data.length === 0 && (
            <p className="text-muted-foreground text-center">No farmers registered yet.</p>
          )}
          {farmers.data?.data.map((farmer: any) => (
            <li key={farmer.name}>
              <FarmerCard
                farmer={farmer}
              />
            </li>
          ))}
        </ul>
      </div>
    </div>
  )
}
